import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { IGroupMountingFilter } from "../models/filters/groupMountingFilter";
import { IGroupMountingForm } from "../models/forms/groupMountingForm";
import { IGroupMountingPDTO } from "../models/dtos/groupMountingPDTO";

// Service for GroupMounting operations
export default class GroupMountingService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/GroupMounting";

    protected static override  getUrlFilter<F extends IGroupMountingFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.mountingPlanId != undefined)
                url += `&MountingPlanId=${filter.mountingPlanId}`;
        }
        
        return url;
    }

    public static override toDTO(obj:IGroupMountingForm):IGroupMountingPDTO {
        const dto = super.toDTO(obj) as IGroupMountingPDTO;
        return dto;
    }
}